import { Fragment, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme)=> ({
    titleSize: { 
        marginTop: 20, 
        fontSize: '1.4rem' 
    },
    tableRowColor: { 
        background: '#212121'
    },
    titlesFlex: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        overflowX: 'auto',
        marginBottom: 10
    },
    title: {
        whiteSpace: "nowrap"
    }
}));

function ReturnRecord() {
    const classes = useStyles();
    const {t} = useTranslation('selfReturn');

    const selfReturnManagement = useSelector(state => state.srReducer);

    const [rows, setRows] = useState([]);
    const [state, setState] = useState({
        [t('id')]: true,
        [t('driver_id')]: true,
        [t('storage_return_id')]: true,
        [t('tno')]: true,
        [t('warehouse')]: true,
        [t('scan_time')]: false,
        [t('append_image')]: true,
        [t('comment')]: true,
        [t('image')]: false,
        [t('is_resolved')]: true,
        [t('is_storaged')]: true,
        [t('new_path_info')]: true,
        [t('new_state')]: true,
        [t('original_path_info')]: false,
        [t('original_state')]: false,
        [t('partial_update')]: true,
        [t('storage_code')]: true,
        [t('storage_info')]: false,
        [t('storage_rotation')]: true
    });
    const [display, setDisplay] = useState({
        [t('id')]: true,
        [t('driver_id')]: true,
        [t('storage_return_id')]: true,
        [t('tno')]: true,
        [t('warehouse')]: true,
        [t('scan_time')]: false,
        [t('append_image')]: true,
        [t('comment')]: true,
        [t('image')]: false,
        [t('is_resolved')]: true,
        [t('is_storaged')]: true,
        [t('new_path_info')]: true,
        [t('new_state')]: true,
        [t('original_path_info')]: false,
        [t('original_state')]: false,
        [t('partial_update')]: true,
        [t('storage_code')]: true,
        [t('storage_info')]: false,
        [t('storage_rotation')]: true
    });
    const displayResponse = {
        [t('id')]: 'id',
        [t('driver_id')]: 'driver_id',
        [t('storage_return_id')]: 'storage_return_id',
        [t('tno')]: 'tno',
        [t('warehouse')]: 'warehouse',
        [t('scan_time')]: 'scan_time',
        [t('append_image')]: 'append_image',
        [t('comment')]: 'comment',
        [t('image')]: 'image',
        [t('is_resolved')]: 'is_resolved',
        [t('is_storaged')]: 'is_storaged',
        [t('new_path_info')]: 'new_path_info',
        [t('new_state')]: 'new_state',
        [t('original_path_info')]: 'original_path_info',
        [t('original_state')]: 'original_state',
        [t('partial_update')]: 'partial_update',
        [t('storage_code')]: 'storage_code',
        [t('storage_info')]: 'storage_info',
        [t('storage_rotation')]: 'storage_rotation'
    };

    const titles = [
        t('id'),
        t('driver_id'),
        t('storage_return_id'),
        t('tno'),
        t('warehouse'),
        t('scan_time'),
        t('append_image'),
        t('comment'),
        t('image'),
        t('is_resolved'),
        t('is_storaged'),
        t('new_path_info'),
        t('new_state'),
        t('original_path_info'),
        t('original_state'),
        t('partial_update'),
        t('storage_code'),
        t('storage_info'),
        t('storage_rotation')
    ]

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
        setDisplay({ ...display, [event.target.name]: !display[event.target.name]});
    };

    useEffect(() => {
        if(selfReturnManagement.returnHistory.data) {
            setRows(selfReturnManagement.returnHistory.data);
        }
    }, [selfReturnManagement.returnHistory])
    
    return (
        <Fragment>
            <div className={classes.titleSize}>{t('return_record')}</div>
            <div className={classes.titlesFlex}>
                {
                    titles.map((title) => (
                        <FormControlLabel
                            key={title}
                            control={
                                <Checkbox 
                                    checked={state[title]} 
                                    onChange={handleChange}
                                    name={title}
                                />
                            }
                            label={title}
                            className={classes.title}
                        />
                    ))
                }               
            </div>
            <Table>
                <TableHead>
                    <TableRow className={classes.tableRowColor}>
                        {
                            titles.map((title) => (
                                display[title] && <TableCell align="center">{title}</TableCell>
                            ))
                        }                           
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.length > 0 && 
                        rows.map((row) => (
                            <TableRow>
                                {
                                    Object.keys(displayResponse).map((key) => (
                                        display[key] && <TableCell align="center">{row[displayResponse[key]]}</TableCell>
                                    ))
                                }
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
        </Fragment>
    );
}

export default ReturnRecord;